export const redirectToClickAndCollectCart = (
  cartId: string,
  isNewEndpoint: boolean
) => {
  window.location.href = isNewEndpoint
    ? `/reservation/${cartId}`
    : `/reservation-1/${cartId}`;
};
